import { createConnector } from 'wagmi'
import { privateKeyToAccount } from 'viem/accounts'
import { type Address } from 'viem'

export function burnerConnector(privateKey: `0x${string}`) {
  return createConnector((config) => ({
    id: 'burner-wallet',
    name: 'Paper Wallet',
    type: 'burner',
    async connect<withCapabilities extends boolean = false>(parameters?: {
      chainId?: number
      isReconnecting?: boolean
      withCapabilities?: withCapabilities | boolean
    }): Promise<{
      accounts: withCapabilities extends true ? readonly { address: Address; capabilities: Record<string, unknown> }[] : readonly Address[]
      chainId: number
    }> {
      const account = privateKeyToAccount(privateKey)

      if (parameters?.withCapabilities) {
        return {
          accounts: [{ address: account.address, capabilities: {} }] as readonly { address: Address; capabilities: Record<string, unknown> }[],
          chainId: config.chains[0].id,
        } as any
      }

      return {
        accounts: [account.address] as readonly [Address, ...Address[]],
        chainId: config.chains[0].id,
      } as any
    },
    async getAccounts() {
      return [privateKeyToAccount(privateKey).address] as const
    },
    async getChainId() {
      return config.chains[0].id
    },
    async getProvider() {
      throw new Error('Burner wallet does not expose a provider')
    },
    async isAuthorized() {
      return true
    },
    async disconnect() {},
    onAccountsChanged() {},
    onChainChanged() {},
    onDisconnect() {},
  }))
}
